import { useMemo } from 'react'
import { useIntl, type IntlShape } from 'react-intl'

import config from 'constants/config'

export function getHolidaySynonymLabels(intl: IntlShape) {
  const isHoliday = config.brandConfig.holidaySynonym === 'holiday'

  return {
    yourHoliday: isHoliday
      ? intl.formatMessage({
          id: '3H8Y4yWGfkwTHd_nqL2d',
          defaultMessage: 'Your holiday',
        })
      : intl.formatMessage({
          id: 'qKqKh4kb_PBxqXcSc_0U',
          defaultMessage: 'Your escape',
        }),

    yourNextHoliday: isHoliday
      ? intl.formatMessage({
          id: 'dIqeYE1ePNC8HQx1LfyQ',
          defaultMessage: 'Your Next Holiday',
        })
      : intl.formatMessage({
          id: '-tXSqlxQ1r6Vp-stG2pz',
          defaultMessage: 'Your Next Escape',
        }),

    creditSnackbarMessage: isHoliday
      ? intl.formatMessage({
          id: '5FKBkYav24fBhi1OGZiK',
          defaultMessage: 'Use it towards your next holiday before it expires. Apply in checkout.',
        })
      : intl.formatMessage({
          id: '4ZfKo7MjWD66I4PL0KVK',
          defaultMessage: 'Use it towards your next escape before it expires. Apply in checkout.',
        }),

    noUpcomingHolidays: isHoliday
      ? intl.formatMessage({
          id: 'kh4QZae-JGDE7lqaEL_6',
          defaultMessage: 'You have no upcoming holidays.',
        })
      : intl.formatMessage({
          id: 'huQzEAK6-rkYkvu4Ppuj',
          defaultMessage: 'You have no upcoming escapes.',
        }),

    whichHolidayToProtect: isHoliday
      ? intl.formatMessage({
          id: 'j57bHiNY9mGi6F74leST',
          defaultMessage: 'Which holiday would you like to protect?',
        })
      : intl.formatMessage({
          id: 'fL4Egg-t0tMFt1SrSW6K',
          defaultMessage: 'Which escape would you like to protect?',
        }),

    lookingForUpcoming: isHoliday
      ? intl.formatMessage({
          id: 'Dk1hM0ShIek5zFDouuG9',
          defaultMessage: 'Looking for upcoming holidays...',
        })
      : intl.formatMessage({
          id: 'S9sPpwXu-fzUrzaTGMEq',
          defaultMessage: 'Looking for upcoming escapes...',
        }),

    customiseYourHoliday: isHoliday
      ? intl.formatMessage({
          id: 'IPgST_kgFbpyAQ4WdMjI',
          defaultMessage: 'Customise your holiday with these experiences',
        })
      : intl.formatMessage({
          id: 'Nn14kCQ7RskGg2nVlG2l',
          defaultMessage: 'Customise your escape with these experiences',
        }),

    cannotPutOnHold: isHoliday
      ? intl.formatMessage({
          id: 'h8-Zr_6RYGiTgJH000s6',
          defaultMessage: 'Your holiday cannot be put on hold just yet, but we are currently working on making this possible so please check back shortly.',
        })
      : intl.formatMessage({
          id: 'nnSSVo05fJYwXVRxJxBx',
          defaultMessage: 'Your escape cannot be put on hold just yet, but we are currently working on making this possible so please check back shortly.',
        }),

    bookedBefore: isHoliday
      ? intl.formatMessage({
          id: 'nBJ_xpOaYOYbeUNfyLHM',
          defaultMessage: 'Looks like you’ve booked a holiday before!',
        })
      : intl.formatMessage({
          id: 'o5kkULPl2LQE06JCYfp_',
          defaultMessage: 'Looks like you’ve booked an escape before!',
        }),
  }
}

function useHolidaySynonymLabels() {
  const intl = useIntl()

  return useMemo(() => getHolidaySynonymLabels(intl), [intl])
}

export default useHolidaySynonymLabels
